import OriginalMenu from './Menu.svelte';
import OriginalItem from './Item.svelte';
import OriginalGroup from './Group.svelte';
import Icon from './Icon.svelte';
import GroupItem from './GroupItem.svelte';
const Menu = OriginalMenu;
Menu.Item = OriginalItem;
Menu.Item.Icon = Icon;
Menu.Group = OriginalGroup;
Menu.Group.Item = GroupItem;
export default Menu;
